const initState = {
    ao: 1,
    risks: [],
    risksDepartmentId: null,
    risksLoading: false,
    error: null,
    isOverlayOpen: false,
    id: null,
    risk: null,
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    go_to_risk_dashboard: null,
    go_to_bowtie: null,
    bowtie: null,
    departments: [],
    sortBy: {},
    sorted_triggered: false,
    preliminary_risk: null,
    changed_page_size: false,
    control_details: null,
    control_comments: null,
    control_logs: [],
    risk_users_list: [],
    finding_comments: null,
    action_details: null,
    action_comments: null,
    action_attachments: null,
    risks_report: [],
    all_risks_report: [],
    risk_controls: [],
    riskControlsScopeKey: null,
    all_risk_controls: [],
    allRiskControlsScopeKey: null,
    compliance_controls: [],
    risk_actions: [],
    risk_incidents: [],
    levels: [],
    actions_stats: [],
    complianceRisks: [],
    complianceRisksScopeKey: null,
    complianceRisksLoading: false,
    department_incidents: [],
};

const controlsScopeKey = (scopeType, scopeId) => `${scopeType}:${scopeId ?? 0}`;

const riskReducer = (state = initState, action) => {




    switch (action.type) {

        case "LEVELS":
            return {
                ...state,
                levels: action.levels,
            };


        case "INCIDENTS_REPORT":
            return {
                ...state,
                risk_incidents: action.risk_incidents,
            };

        case "ACTIONS_REPORT":
            return {
                ...state,
                risk_actions: action.risk_actions,
            };

        case "CONTROLS_REQUEST": {
            const nextKey = controlsScopeKey(action.scopeType, action.scopeId);
            const isScopeChange = nextKey !== state.riskControlsScopeKey;
            return {
                ...state,
                risk_controls: isScopeChange ? [] : state.risk_controls,
                riskControlsScopeKey: nextKey,
            };
        }

        case "CONTROLS_REPORT":
            if (
                action.scopeKey != null &&
                state.riskControlsScopeKey != null &&
                action.scopeKey !== state.riskControlsScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                risk_controls: action.risk_controls,
                riskControlsScopeKey: action.scopeKey ?? state.riskControlsScopeKey,
            };

        case "ALL_CONTROLS_REQUEST": {
            const nextKey = controlsScopeKey("dept", action.department_id);
            const isScopeChange = nextKey !== state.allRiskControlsScopeKey;
            return {
                ...state,
                all_risk_controls: isScopeChange ? [] : state.all_risk_controls,
                allRiskControlsScopeKey: nextKey,
            };
        }

        case "CONTROLS_SEARCH":
            if (
                action.scopeKey != null &&
                state.allRiskControlsScopeKey != null &&
                action.scopeKey !== state.allRiskControlsScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                all_risk_controls: action.risk_controls,
                allRiskControlsScopeKey: action.scopeKey ?? state.allRiskControlsScopeKey,
                visibleFindingCount: action.visibleFindingCount ?? 0,
            };

        case "COMPLIANCE_CONTROLS_REPORT":
            return {
                ...state,
                compliance_controls: action.compliance_controls,
            };

        case "RISKS_REPORT":
            return {
                ...state,
                risks_report: action.risks_report,
            };
        case "ALL_RISKS_REPORT":
            return {
                ...state,
                all_risks_report: action.risks_report,
            };

        case "ACTION_DETAILS":
            return {
                ...state,
                action_details: action.action_details,
                action_comments: action.comments,
                action_attachments: action.attachments,
            };
        case "UPDATE_ACTION_PROGRESS":
            return {
                ...state,
                actions: state.actions.map((a) =>
                    a.action_id === action.payload.action_id ? { ...a, progress: action.payload.progress } : a
                ),
            };

        case "CONTROL_LOGS":
            return { ...state, control_logs: action.logs };

        case "RISK_USERS_LIST":
            return { ...state, risk_users_list: action.users };

        case "CONTROL_DETAILS":
            //////console.log("CONTROL_DETAILS action received:", action);
            //////console.log(" control_details.start_date before setting state:", action.control_details.start_date);
            ////console.log("CONTROL_DETAILS")
            return {
                ...state,
                control_details: {
                    ...action.control_details, // Now includes attachments from the action

                },
                control_comments: action.comments ?? state.control_comments, // Ensure comments are updated correctly
            };

        case "ADD_ATTACHMENT":
            return {
                ...state,
                control_details: {
                    ...state.control_details,
                    attachments: [...(state.control_details.attachments || []), action.attachment],
                },
            };

        case "DELETE_ATTACHMENT":
            return {
                ...state,
                control_details: {
                    ...state.control_details,
                    attachments: state.control_details.attachments.filter(
                        (attachment) => attachment.attachment_id !== action.attachment_id
                    ),
                },
            };

        case "RESETALLTABLEDEFINITIONS":
            return {
                ...state,
                currentPage: 1,
                pageSize: 10,

            };

        case "RESET_PRELIMINARY_RISK":
            return {
                ...state,
                preliminary_risk: null,
            };

        case "DEPARTMENTS":
            return {
                ...state,
                departments: action.departments,
            };

        case "RESET_GOTO_RISK_DASHBOARD":
            return {
                ...state,
                go_to_risk_dashboard: null,
            };

        case "GOTO_RISK_DASHBOARD":
            return {
                ...state,
                go_to_risk_dashboard: action.risk_id,
            };

        case "RESET_GOTO_BOWTIE":
            return {
                ...state,
                go_to_bowtie: null,
                bowtie: null
            };

        case "GOTO_BOWTIE":
            return {
                ...state,
                go_to_bowtie: action.risk_id,
            };

        case "BOWTIE":
            return {
                ...state,
                bowtie: action.bowtie,
            };

        case "BOWTIE_CLOSE":
            return {
                ...state,
                go_to_bowtie: null,
                bowtie: null
            };

        case "RESET_SORTED_TRIGGERED":
            return {
                ...state,
                sorted_triggered: false,
            };

        case "RESET_CHANGED_PAGE_SIZE":
            return {
                ...state,
                changed_page_size: false,
            };

        case "SET_SORT_BY":
            return {
                ...state,
                sortBy: action.sortBy,
                sorted_triggered: true,
            };

        case "SET_CURRENT_PAGE":
            if (state.currentPage === action.currentPage) {
                return state;
            }
            return {
                ...state,
                currentPage: action.currentPage,
                sorted_triggered: true,
            };


        case "CREATE_PRELIMINARY_RISK":
            return {
                ...state,
                preliminary_risk: action.preliminary_risk,
            };

        case "SET_PAGE_SIZE":
            if (state.pageSize === action.pageSize) {
                return state;
            }
            return {
                ...state,
                pageSize: action.pageSize,
                changed_page_size: true,
            };

        case "RISK":
            //console.log('Risk reducer - Received risk data:', action.risk);
            return {
                ...state,
                risk: action.risk,
            };

        case "CONTROL_FINDINGS_REPLACE":
            ////console.log("FINDINGS_REPALCE")
            return {
                ...state,
                control_details: {
                    ...state.control_details,
                    findings: action.payload.findings,
                },
            };

        case "CONTROL_TESTS_REPLACE":
            return {
                ...state,
                control_details: {
                    ...state.control_details,
                    tests: action.tests,
                },
            };

        case "FINDING_DETAILS_SET":
            ////console.log("FINDING_DETAILS")
            return {
                ...state,
                control_details: {
                    ...state.control_details,
                    finding_details: action.payload, 
                    finding_comments: action.comments,
                },
            };

        case "OPEN_OVERLAY":
            return {
                ...state,
                isOverlayOpen: true,
                id: action.id
            };

        case "CLOSE_OVERLAY":
            ////console.log("Overley Closed")
            return {
                ...state,
                isOverlayOpen: false,
                id: null,
                risk: null,
            };

        case "CLOSE_CONTROL":
            ////console.log("CLOSE_CONTROL")
            return {
                ...state,
                control_details: null,
            };

        case "RESET_ERROR":
            return {
                ...state,
                //risks: [],
                error: null,
            };

        case "RESET_NEWLYCREATED_RISK_ID":
            return {
                ...state,
                newlycreatedRiskId: null,
            };



        case "RISK_DELETED":
            return {
                ...state,
                risks: state.risks.filter((r) => r.ID !== action.risk_id),
                complianceRisks: state.complianceRisks.filter((r) => r.ID !== action.risk_id),
            };

        case "RISKS_REQUEST": {
            const isDepartmentChange =
                action.department_id != null &&
                String(action.department_id) !== String(state.risksDepartmentId);
                //console.log("Setting laoding to true ", isDepartmentChange)
            return {
                ...state,
                risks: isDepartmentChange ? [] : state.risks,
                risksDepartmentId: action.department_id ?? state.risksDepartmentId,
                risksLoading: state.risksLoading || isDepartmentChange,
            };
        }

        case "RISKS_FETCH_FAILED":
        case "RISKS_RESET_LOADING":
            //console.log("Setting loaidng risk to flase in Reset")
            return {
                ...state,
                risksLoading: false,
            };

        case "RISKS": {
            // Stale response from a previous department fetch — discard the data
            // but still clear risksLoading so the spinner never gets stuck.
            const isStale =
                action.department_id != null &&
                state.risksDepartmentId != null &&
                String(action.department_id) !== String(state.risksDepartmentId);

            //console.log("Setting laoding to false ", isStale)
            if (isStale) {
                return { ...state, risksLoading: false };
            }
            return {
                ...state,
                risks: action.risks,
                totalPages: action.totalPages,
                risksDepartmentId: action.department_id ?? state.risksDepartmentId,
                risksLoading: false,
                risk: null,
                newlycreatedRiskId: action.newlycreatedRiskId ? action.newlycreatedRiskId : null,
            };
        }

        case "COMPLIANCE_RISKS_REQUEST": {
            const nextKey = controlsScopeKey("comp", action.compliance_id);
            const isScopeChange = nextKey !== state.complianceRisksScopeKey;
            return {
                ...state,
                complianceRisks: isScopeChange ? [] : state.complianceRisks,
                complianceRisksScopeKey: nextKey,
                complianceRisksLoading: true,
            };
        }

        case "COMPLIANCE_RISKS_LOADED":
            return {
                ...state,
                complianceRisksLoading: false,
            };

        case "COMPLIANCE_RISKS":
            if (
                action.scopeKey != null &&
                state.complianceRisksScopeKey != null &&
                action.scopeKey !== state.complianceRisksScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                complianceRisks: action.complianceRisks,
                complianceTotalPages: action.totalPages,
                risk: null,
                complianceRisksScopeKey: action.scopeKey ?? state.complianceRisksScopeKey,
                complianceRisksLoading: false,
                newlyCreatedComplianceRiskId: action.newlyCreatedComplianceRiskId ? action.newlyCreatedComplianceRiskId : null,
            };


        case "ERROR_CREATING_RISK":
            return {
                ...state,
                error: action.error,
            };

        case "DEPARTMENT_INCIDENTS":
            return {
                ...state,
                department_incidents: action.department_incidents,
            };

        case "ACTIONS_STATS":
            return {
                ...state,
                actions_stats: action.risk_actions



            }

        default:
            return state;
    }
};

export default riskReducer;
